<template>
  <div class="options-popup">
    <div class="popup-card">
      <div v-for="option in generalChatOptions" :key="option.id" class="response-option" @click="sendGeneralChat(option)">{{ option.message }}</div>
    </div>
  </div>
</template>

<script setup>
import { useChatStore } from '~~/stores/chat';
import { useCountryStore } from '~~/stores/country';

const route = useRoute();

const chatStore = useChatStore();
const countryStore = useCountryStore();

const props = defineProps({
  flowPosition: {
    type: String,
    required: true,
  }
})

const generalChatOptions = computed(() => chatStore.generalChatOptions);

function sendGeneralChat(message) {
  chatStore.history.push({
    id: chatStore.history.length,
    message: message.message,
    messageId: message.responseId,
    sentBy: "USER",
    createdAt: "sending...",
  });
  chatStore.chat({
    publicId: route.params.publicId ?? route.params.prescoreId,
    flowPosition: props.flowPosition,
    locale: countryStore.shortLocale,
    message: message.message,
    responseId: message.responseId,
    isGeneralChat: true,
  })
}
</script>

<style scoped lang="scss">
.options-popup {
  position: absolute;
  bottom: 40%;
  // background: red;
  // background: black;
  padding-bottom: 35px;
  filter: drop-shadow(0px 2px 8px #232f3517);
  
  .popup-card {
    // padding: 10px;
    background: white;
    border-radius: 12px;
    // box-shadow: 0 2px 8px 0 #232F3517;
    // box-shadow: 2.5px 2.5px 1px 5px red;

    display: flex;
    flex-direction: column;

    .response-option {
      font-size: 14px;
      line-height: 18px;
      padding: 10px 20px;
      border: none;
      color: var(--black);
      cursor: pointer;

      // &:not(:last-of-type) {
      //   border-bottom: 1px solid var(--gray200);
      // }
      
      &:hover {
        background: var(--gray50);
      }
    }
  }
}
</style>